import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { PaymentDetailsInvoice } from '../modal/invoice';

interface GetPaymentDetailsParams {
  date: string;
}

interface GetPaymentDetailsResponse {
  totalPayments: number;
  totalAmount: string;
  successful: Array<PaymentDetailsInvoice>;
  failed: Array<PaymentDetailsInvoice>;
  pending?: Array<PaymentDetailsInvoice>;
  upcoming?: Array<PaymentDetailsInvoice>;
  scheduled?: Array<PaymentDetailsInvoice>;
  invoices: Array<PaymentDetailsInvoice>;
}

export const getPaymentDetails = async (params: GetPaymentDetailsParams) => {
  const response = await baseAPI.get<GetPaymentDetailsResponse>(
    `subscription-invoices/payment-details`,
    {
      params: {
        ...params,
      },
    },
  );
  return response.data;
};

export const useGetPaymentDetails = (params: GetPaymentDetailsParams) => {
  return useQuery({
    queryKey: [KEYS.PAYMENT_DETAILS, params.date],
    queryFn: () => getPaymentDetails(params),
    // Keep prior report rows visible while retry invalidates (ENR-2160 flicker).
    placeholderData: keepPreviousData,
  });
};
